module.exports = __webpack_public_path__ + "static/media/DZ.c077fa9d.svg";